import type { StampEvidence } from "@peer-start/platform-contracts";
import { Disclosure } from "@peer-start/ui";
import { History } from "lucide-react";
import { useTranslation } from "react-i18next";

export function StampEvidenceHistory({ evidence }: { evidence: StampEvidence[] }) {
  const { t, i18n } = useTranslation();
  return (
    <Disclosure
      controlId="passport.history.toggle"
      title={
        <span className="flex items-center gap-2">
          <History aria-hidden="true" className="size-4 text-primary" />
          {t("passportVig.history.title")}
          <span className="font-normal text-muted-foreground">({evidence.length})</span>
        </span>
      }
    >
      {evidence.length ? (
        <ol className="mt-4 space-y-2">
          {evidence.map((item) => (
            <li className="rounded-lg border border-border p-3" key={item.id}>
              <div className="flex flex-wrap items-start justify-between gap-2">
                <p className="text-sm font-medium">{t(`passportVig.evidenceTypes.${item.type}`)}</p>
                <time className="text-xs text-muted-foreground">
                  {new Intl.DateTimeFormat(i18n.language, {
                    dateStyle: "medium",
                    timeStyle: "short",
                  }).format(new Date(item.createdAt))}
                </time>
              </div>
              <p className="mt-1 text-sm text-muted-foreground">{item.context}</p>
              <p className="mt-1 text-xs text-muted-foreground">
                {t("passportVig.history.source", { source: item.source })}
              </p>
            </li>
          ))}
        </ol>
      ) : (
        <p className="mt-3 text-sm text-muted-foreground">{t("passportVig.history.empty")}</p>
      )}
    </Disclosure>
  );
}
